import { useContext } from '@builder.io/qwik';
import { AppDataContext } from '~/contexts/AppDataContext';
import { cva } from 'class-variance-authority';
import { getCSSVerticalSpacingFactor } from '~/utilities/getCSS';
import { useIsPremiumTemplate } from '~/utilities/useIsPremiumTemplate';

const cssClasses = cva('', {
  variants: {
    blockSpacing: getCSSVerticalSpacingFactor(),
  },
});

export const useBlockClasses = () => {
  const { themeComponents } = useContext(AppDataContext);

  const isPremium = useIsPremiumTemplate();

  return cssClasses({
    blockSpacing: isPremium
      ? 1.5
      : (themeComponents.articleContent.marginBetweenBlocksFactor.value as
          | 0
          | 0.5
          | 1
          | 1.3
          | 1.5
          | 2
          | null
          | undefined),
  });
};
